import { Add, GridView, Plus } from "@mui/icons-material";
import styled from "styled-components";
import { ButtonTable } from "../../Layouts/ButtonsControlled";

const HeaderTable = (props) => {
    return <TableHeaderStyled>{props.children}</TableHeaderStyled>;
};
const TableHeaderStyled = styled.div`
    margin: 2rem 1rem;
    padding: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: var(--light-gray);
    border-radius: var(--border-radius);
    box-shadow: 0 5px 8px var(--box-shadow);
    .title {
        display: flex;
        align-items: center;
        svg {
            margin-right: 0.8rem;
            color: var(--dark);
        }
        span {
            font-size: 1.2rem;
            font-weight: bold;
            text-transform: uppercase;
            letter-spacing: 1px;
            color: var(--dark);
        }
    }
    .route-active {
        color: var(--light-blue);
        font-weight: bold;
    }
    .route-not-active {
        font-weight: bold;
        color: var(--gray);
    }
`;

export default HeaderTable;
